<template>
  <div class="paginationContainer" :style="getStyle">
    <el-pagination
      ref="page"
      :prev-text="pageTurnType === 'font' ? '上一页' : ''"
      :next-text="pageTurnType === 'font' ? '下一页' : ''"
      :pager-count="maxPageBtnNum"
      :style="getPaginationStyle"
      :layout="defaultLayout"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { isSsrPage } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
export default {
  mixins: [eventMixin, subPageEventMixin],
  name: "cxPagination",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    //  获取当前操作的组件id
    ids() {
      return this.$store.state.states.activeID
    },
    currentPage() {
      return this.options.value
    },
    total() {
      return this.options.total
    },
    pageSize() {
      return this.options.pageSize
    },
    showJumper() {
      return this.options.showJumper
    },
    showTotal() {
      return this.options.showTotal
    },
    maxPageBtnNum() {
      return this.options.maxPageBtnNum
    },
    defaultLayout() {
      let defaultLayout = ""
      if (this.showTotal) {
        defaultLayout += "total,prev, pager, next"
      } else {
        defaultLayout = "prev, pager, next"
      }
      if (this.showJumper) {
        defaultLayout += ",jumper"
      }
      return defaultLayout
    },
    pageTurnType() {
      return this.options.pageTurnType
    },
    hideOnSinglePage() {
      return this.options.hideOnSinglePage
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgColor() {
      return this.$parseColor(this.options.bgColor, {
        isThemeColor: this.options.bgColorIsThemeColor
      })
    },
    borderColor() {
      return this.$parseColor(this.options.borderColor, {
        isThemeColor: this.options.borderIsThemeColor
      })
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    getPageTurnPaddingStyle() {
      let padding = `${this.options.pageTurnPadding}px`
      if (this.options.pageTurnPaddingTypeFlag === 2) {
        padding = ` ${this.options.pageTurnPaddingTop}px  ${this.options.pageTurnPaddingRight}px  ${this.options.pageTurnPaddingBottom}px  ${this.options.pageTurnPaddingLeft}px`
      }
      return padding
    },
    getHoverPageTurnPaddingStyle() {
      let padding = `${this.options.hoverPageTurnPadding}px`
      if (this.options.hoverPageTurnPaddingTypeFlag === 2) {
        padding = ` ${this.options.hoverPageTurnPaddingTop}px  ${this.options.hoverPageTurnPaddingRight}px  ${this.options.hoverPageTurnPaddingBottom}px  ${this.options.hoverPageTurnPaddingLeft}px`
      }
      return padding
    },
    getActivePaddingStyle() {
      let padding = `${this.options.activePadding}px`
      if (this.options.activePaddingTypeFlag === 2) {
        padding = ` ${this.options.activePaddingTop}px  ${this.options.activePaddingRight}px  ${this.options.activePaddingBottom}px  ${this.options.activePaddingLeft}px`
      }
      return padding
    },
    getHoverPaddingStyle() {
      let padding = `${this.options.hoverPadding}px`
      if (this.options.hoverPaddingTypeFlag === 2) {
        padding = ` ${this.options.hoverPaddingTop}px  ${this.options.hoverPaddingRight}px  ${this.options.hoverPaddingBottom}px  ${this.options.hoverPaddingLeft}px`
      }
      return padding
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("allBgColorIsThemeColor")
              ? this.options.allBgColorIsThemeColor
              : false,
            color: this.options.allBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    activeBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.activeBoxShadowH)) {
        this.options.activeBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.activeBoxShadowH[index]}px ${_this.options.activeBoxShadowV[index]}px ${_this.options.activeBoxShadowBlur[index]}px ${_this.options.activeBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.activeBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.activeBoxShadowH}px ${this.options.activeBoxShadowV}px ${this.options.activeBoxShadowBlur}px ${this.options.activeBoxShadowSpread}px ${this.$parseColor(this.options.activeBoxShadowColor)}`
      }
      return tmpStyle
    },
    allBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.allBoxShadowH)) {
        this.options.allBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.allBoxShadowH[index]}px ${_this.options.allBoxShadowV[index]}px ${_this.options.allBoxShadowBlur[index]}px ${_this.options.allBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.allBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.allBoxShadowH}px ${this.options.allBoxShadowV}px ${this.options.allBoxShadowBlur}px ${this.options.allBoxShadowSpread}px ${this.$parseColor(this.options.allBoxShadowColor)}`
      }
      return tmpStyle
    },
    hoverBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.hoverBoxShadowH)) {
        this.options.hoverBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.hoverBoxShadowH[index]}px ${_this.options.hoverBoxShadowV[index]}px ${_this.options.hoverBoxShadowBlur[index]}px ${_this.options.hoverBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.hoverBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.hoverBoxShadowH}px ${this.options.hoverBoxShadowV}px ${this.options.hoverBoxShadowBlur}px ${this.options.hoverBoxShadowSpread}px ${this.$parseColor(this.options.hoverBoxShadowColor)}`
      }
      return tmpStyle
    },
    getAllPaddingStyle() {
      let padding = `${this.options.allPadding}px`
      if (this.options.allPaddingTypeFlag === 2) {
        padding = ` ${this.options.allPaddingTop}px  ${this.options.allPaddingRight}px  ${this.options.allPaddingBottom}px  ${this.options.allPaddingLeft}px`
      }
      return padding
    },
    getStyle() {
      let borderW = ""
      if (Array.isArray(this.options.allBorderWidth)) {
        this.options.allBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.allBorderWidth}px`
      }
      return {
        ...this.bgStyle,
        opacity: this.options.opacity / 100,
        "box-shadow": this.allBoxShadowStyle,
        "border-top-left-radius": this.options.allBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.allBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.allBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.allBorderBottomLeftRadius + "px",
        "border-style": this.options.allBorderStyle,
        // "border-color": this.options.allBorderColor,
        "border-color": this.$parseColor(this.options.allBorderColor),
        "border-width": borderW,
        padding: this.getAllPaddingStyle
      }
    },
    pageTurnIcon() {
      let pageTurnIcon = this.options.pageTurnIcon
      if (pageTurnIcon && pageTurnIcon.indexOf("portal") === -1) {// 兼容以前的图标
        pageTurnIcon = pageTurnIcon.replace("icon", "icon-portal")
      }
      console.log('pageTurnIcon :>>',pageTurnIcon);
      return pageTurnIcon
    },
    defaultStyle() {
      let borderW = "",
        borderLeft = "",
        pageTurnBorderW = "",
        activeBorderW = "",
        hoverBorderW = "",
        hoverPageTurnBorderW = ""
      // paddingBorderH = 0 //padding+border的高度
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        borderLeft = this.options.borderWidth[0] + "px"
        // paddingBorderH = this.options.borderWidth[0] + this.options.borderWidth[1]
      } else {
        borderW += ` ${this.options.borderWidth}px`
        borderLeft = this.options.borderWidth + "px"
        // paddingBorderH = 2* this.options.borderWidth
      }
      if (Array.isArray(this.options.pageTurnBorderWidth)) {
        this.options.pageTurnBorderWidth.forEach(item => [(pageTurnBorderW += ` ${item}px`)])
      } else {
        pageTurnBorderW += ` ${this.options.pageTurnBorderWidth}px`
      }
      if (Array.isArray(this.options.hoverPageTurnBorderWidth)) {
        this.options.hoverPageTurnBorderWidth.forEach(item => [(hoverPageTurnBorderW += ` ${item}px`)])
      } else {
        hoverPageTurnBorderW += ` ${this.options.hoverPageTurnBorderWidth}px`
      }
      if (Array.isArray(this.options.activeBorderWidth)) {
        this.options.activeBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
      } else {
        activeBorderW += ` ${this.options.activeBorderWidth}px`
      }
      if (Array.isArray(this.options.hoverBorderWidth)) {
        this.options.hoverBorderWidth.forEach(item => [(hoverBorderW += ` ${item}px`)])
      } else {
        hoverBorderW += ` ${this.options.hoverBorderWidth}px`
      }

      return {
        color: this.$parseColor(this.options.color),
        "--fontSize": this.options.fontSize + "px",
        "font-family": this.options.fontFamily || "",
        "font-weight": this.options.fontWeight,
        "font-style": this.options.fontStyle,
        "--textDecoration": this.options.textDecoration,
        "--lineHeight": this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) : this.options.lineHeight + "px",
        // "letter-spacing": this.options.letterSpacing + "px",
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "--borderRadius": `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`,
        "--borderStyle": this.options.borderStyle,
        "--borderColor": this.$parseColor(this.options.borderColor),
        "--borderWidth": this.options.isShowBackgroundModel === "无背景" ? "0px" : borderW,
        "--borderLeft": borderLeft,
        "--background": this.bgColor,
        "--marginLeft": this.options.itemMargin / 2 + "px",
        "--minWidth": this.options.minWidth + "px",
        "--padding": this.getPaddingStyle,
        "--boxShadow": this.boxShadowStyle,
        "--color": this.$parseColor(this.options.color),
        "--iconColor": this.$parseColor(this.options.pageTurnIconColor, {
          isThemeColor: this.options.pageTurnIconIsThemeColor
        }),
        "--pageTurnHeight": this.options.pageTurnHeight + "px",
        "--pageTurnMinWidth": this.options.pageTurnMinWidth + "px",
        "--pageTurnBgColor": this.$parseColor(this.options.pageTurnBgColor, {
          isThemeColor: this.options.pageTurnBgIsThemeColor
        }),
        "--pageTurnBorderStyle": this.options.pageTurnBorderStyle,
        "--pageTurnBorderColor": this.$parseColor(this.options.pageTurnBorderColor),
        "--pageTurnBorderWidth": pageTurnBorderW,
        "--pageTurnBorderRadius": `${this.options.pageTurnBorderTopLeftRadius}px ${this.options.pageTurnBorderTopRightRadius}px ${this.options.pageTurnBorderBottomRightRadius}px ${this.options.pageTurnBorderBottomLeftRadius}px`,
        "--pageTurnPadding": this.getPageTurnPaddingStyle,
        "--pageTurnFontWeight": this.options.pageTurnFontWeight,
        "--pageTurnFontFamily": this.options.pageTurnFontFamily,
        "--pageTurnFontSize": this.options.pageTurnFontSize + "px",
        "--pageTurnFontColor": this.$parseColor(this.options.pageTurnFontColor),
        "--pageTurnIconColor": this.$parseColor(this.options.pageTurnIconColor, {
          isThemeColor: this.options.pageTurnIconIsThemeColor
        }),

        "--hoverPageTurnBgColor": this.$parseColor(this.options.hoverPageTurnBgColor, {
          isThemeColor: this.options.hoverPageTurnBgIsThemeColor
        }),
        "--hoverPageTurnBorderStyle": this.options.hoverPageTurnBorderStyle,
        "--hoverPageTurnBorderColor": this.$parseColor(this.options.hoverPageTurnBorderColor),
        "--hoverPageTurnBorderWidth": hoverPageTurnBorderW,
        "--hoverPageTurnBorderRadius": `${this.options.hoverPageTurnBorderTopLeftRadius}px ${this.options.hoverPageTurnBorderTopRightRadius}px ${this.options.hoverPageTurnBorderBottomRightRadius}px ${this.options.hoverPageTurnBorderBottomLeftRadius}px`,
        "--hoverPageTurnPadding": this.getHoverPageTurnPaddingStyle,
        "--hoverPageTurnFontColor": this.$parseColor(this.options.hoverPageTurnFontColor),
        "--hoverPageTurnIconColor": this.$parseColor(this.options.hoverPageTurnIconColor, {
          isThemeColor: this.options.hoverPageTurnIconIsThemeColor
        }),

        "--activeColor": this.$parseColor(this.options.activeColor),
        "--activeFontSize": this.options.activeFontSize + "px",
        "--activeFontFamily": this.options.activeFontFamily || "",
        "--activeFontWeight": this.options.activeFontWeight,
        "--activeBgColor": this.$parseColor(this.options.activeBgColor, {
          isThemeColor: this.options.activeBgColorIsThemeColor
        }),
        "--activeBoxShadow": this.activeBoxShadowStyle,
        "--activeBorderRadius": `${this.options.activeBorderTopLeftRadius}px ${this.options.activeBorderTopRightRadius}px ${this.options.activeBorderBottomRightRadius}px ${this.options.activeBorderBottomLeftRadius}px`,
        "--activeBorderStyle": this.options.activeBorderStyle,
        "--activeBorderColor": this.$parseColor(this.options.activeBorderColor),
        "--activeBorderWidth": activeBorderW,
        "--activePadding": this.getActivePaddingStyle,

        "--hoverColor": this.$parseColor(this.options.hoverColor),
        "--hoverFontSize": this.options.hoverFontSize + "px",
        "--hoverFontFamily": this.options.hoverFontFamily || "",
        "--hoverFontWeight": this.options.hoverFontWeight,
        "--hoverBgColor": this.$parseColor(this.options.hoverBgColor, {
          isThemeColor: this.options.hoverBgColorIsThemeColor
        }),
        "--hoverBoxShadow": this.hoverBoxShadowStyle,
        "--hoverBorderRadius": `${this.options.hoverBorderTopLeftRadius}px ${this.options.hoverBorderTopRightRadius}px ${this.options.hoverBorderBottomRightRadius}px ${this.options.hoverBorderBottomLeftRadius}px`,
        "--hoverBorderStyle": this.options.hoverBorderStyle,
        "--hoverBorderColor": this.$parseColor(this.options.hoverBorderColor),
        "--hoverBorderWidth": hoverBorderW,
        "--hoverPadding": this.getHoverPaddingStyle,

        "--otherFontColor": this.$parseColor(this.options.otherFontColor),
        "--otherFontSize": this.options.otherFontSize + "px",
        "--otherFontFamily": this.options.otherFontFamily || "",
        "--otherFontWeight": this.options.otherFontWeight
      }
    },
    getPaginationStyle() {
      return this.defaultStyle
    },
  },
  watch: {
    pageTurnIcon(newVal, oldVal) {
      if (this.$refs.page) {
        this.setPageTurnIcon()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setPageTurnIcon()
    })
  },
  methods: {
    setPageTurnIcon() {
      if (this.options.pageTurnType !== "icon" && this.options.total > this.options.pageSize) {
        return
      }
      if (!this.$refs.page) {
        return
      }
      let btnPrev = this.$refs.page.$el.getElementsByClassName("btn-prev")[0]
      let btnNext = this.$refs.page.$el.getElementsByClassName("btn-next")[0]
      btnPrev.getElementsByTagName("i")[0] &&
        (btnPrev.getElementsByTagName("i")[0].className = `cx-icon ${this.pageTurnIcon}`)
      btnNext.getElementsByTagName("i")[0] &&
        (btnNext.getElementsByTagName("i")[0].className = `cx-icon ${this.pageTurnIcon}`)
    },
    handleSizeChange() {},
    handleCurrentChange(curPage) {
      this.$changeOptionsEV(curPage, "value", false, false, false, true)
      // 选中页码发生改变
      try {
        let param = {
          ...this.myid,
          option_name: "value",
          option_val: curPage
        }
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      } catch (e) {
      }
      this.dispatchListPageRefreshData(curPage)
    },
    // 触发列表页数据刷新
    dispatchListPageRefreshData(pageNum) {
      if (this.$subPageEvent.contexts) {
        Object.keys(this.$subPageEvent.contexts).forEach(key => {
          if (key.indexOf("cxDataGrid") !== -1) {
            ///this.$subPageEvent.contexts[key].initListPageDataGridData(this)
            this.$eventBus.$emit("subPage-component-init", {
              type: key,
              pageNum: pageNum
            })
          }
        })
      }
    },
    // 初始化列表页分页组件
    initSubPagePaginationData(totalRecords, pageSize, plugin) {
      this.$changeOptionsEV(plugin.showDataGrid, "display", false, false, false, true)
      this.$changeOptionsEV(totalRecords, "total", false, false, false, true)
      this.$changeOptionsEV(pageSize, "pageSize", false, false, false, true)
    }
  }
}
</script>

<style scoped>
.paginationContainer {
  width: 100%;
  height: 100%;
}
::v-deep .el-pagination .el-pagination__total,
::v-deep .el-pagination .el-pagination__jump {
  color: var(--otherFontColor);
  font-size: var(--otherFontSize) !important;
  font-weight: var(--otherFontWeight);
  font-family: var(--otherFontFamily);
  height: var(--lineHeight);
  line-height: var(--lineHeight);
  margin-left: 10px;
}
::v-deep.el-input .el-input__inner:focus {
  border: none !important;
}
::v-deep .el-input {
  vertical-align: middle;
}
::v-deep .el-pager li {
  vertical-align: middle;
  height: var(--lineHeight);
  line-height: var(--lineHeight);
  font-size: var(--fontSize);
  text-decoration: var(--textDecoration);
  margin: 0 var(--marginLeft);
  background-color: var(--background);
  color: var(--color);
  padding: var(--padding);
  min-width: var(--minWidth);
  border-width: var(--borderWidth);
  border-style: var(--borderStyle);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  box-shadow: var(--boxShadow);
  box-sizing: content-box;
}
::v-deep .el-pager li:hover {
  font-size: var(--hoverFontSize);
  font-family: var(--hoverFontFamily);
  font-weight: var(--hoverFontWeight);
  color: var(--hoverColor);
  background-color: var(--hoverBgColor);
  padding: var(--hoverPadding);
  border-width: var(--hoverBorderWidth);
  border-style: var(--hoverBorderStyle);
  border-color: var(--hoverBorderColor);
  border-radius: var(--hoverBorderRadius);
  box-shadow: var(--hoverBoxShadow);
}
::v-deep .el-pager li.active {
  font-size: var(--activeFontSize);
  font-family: var(--activeFontFamily);
  font-weight: var(--activeFontWeight);
  color: var(--activeColor);
  background-color: var(--activeBgColor);
  padding: var(--activePadding);
  border-width: var(--activeBorderWidth);
  border-style: var(--activeBorderStyle);
  border-color: var(--activeBorderColor);
  border-radius: var(--activeBorderRadius);
  box-shadow: var(--activeBoxShadow);
}

::v-deep .el-pager li.active + li {
  border-left: var(--borderLeft) var(--borderStyle) var(--borderColor);
  border-width: var(--borderWidth);
}
::v-deep .el-pager li.active + li:hover {
  border-width: var(--hoverBorderWidth);
}

::v-deep.el-pagination button:disabled {
  background: var(--pageTurnBgColor);
  opacity: 0.4;
}
::v-deep .btn-next,
::v-deep .btn-prev {
  /*height: var(--pageTurnHeight);*/
  height: var(--pageTurnHeight);
  line-height: var(--pageTurnHeight);
  min-width: var(--pageTurnMinWidth);
  background: var(--pageTurnBgColor);
  border-width: var(--pageTurnBorderWidth);
  border-style: var(--pageTurnBorderStyle);
  border-color: var(--pageTurnBorderColor);
  border-radius: var(--pageTurnBorderRadius);
  padding: var(--pageTurnPadding);
  font-size: var(--pageTurnFontSize);
  margin: 0 var(--marginLeft);
  box-sizing: content-box;
}

::v-deep .btn-next:hover,
::v-deep .btn-prev:hover {
  background: var(--hoverPageTurnBgColor);
  border-width: var(--hoverPageTurnBorderWidth);
  border-style: var(--hoverPageTurnBorderStyle);
  border-color: var(--hoverPageTurnBorderColor);
  border-radius: var(--hoverPageTurnBorderRadius);
  padding: var(--hoverPageTurnPadding);
}
::v-deep .btn-next:hover span,
::v-deep .btn-prev:hover span {
  display: inline-block;
  color: var(--hoverPageTurnFontColor);
}
::v-deep .btn-next:hover .cx-icon,
::v-deep .btn-prev:hover .cx-icon,
::v-deep .btn-next:hover .cx-icon:before,
::v-deep .btn-prev:hover .cx-icon:before {
  color: var(--hoverPageTurnIconColor);
}

::v-deep .btn-next span,
::v-deep .btn-prev span {
  display: inline-block;
  height: var(--pageTurnHeight);
  line-height: var(--pageTurnHeight);
  color: var(--pageTurnFontColor);
  font-weight: var(--pageTurnFontWeight);
  font-family: var(--pageTurnFontFamily);
  font-size: var(--pageTurnFontSize);
}
::v-deep .cx-icon,
::v-deep .cx-icon:before {
  color: var(--pageTurnIconColor);
}
::v-deep .btn-next .cx-icon {
  display: inline-block;
  transform: rotateY(180deg);
}
.el-pagination button:disabled {
  opacity: 0.5;
}
::v-deep .el-pager,
::v-deep.el-pagination button,
::v-deep.el-pagination span:not([class*="suffix"]),
::v-deep .el-pagination button {
  vertical-align: middle;
}
::v-deep .el-pager .more::before {
  line-height: unset;
}
::v-deep .el-pagination__jump .el-input {
  width: 40px;
  height: var(--lineHeight);
}
::v-deep .el-pagination .el-input__inner {
  background-color: #ffffff;
  border: 1px solid #edf1f7;
  border-radius: 8px;
  height: 32px;
}
::v-deep .el-pagination__jump .el-input__inner {
  padding: 0 3px;
}
::v-deep .el-pagination .el-input__inner:hover {
  background: #fafbfe;
}
::v-deep .el-pager .el-icon-more {
  line-height: 24px;
}
::v-deep .el-pager .el-icon-more::before {
  content: "...";
}
::v-deep .el-pagination {
  padding: 0;
}
</style>
